import script from "./FieldsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsTable.vue?vue&type=script&setup=true&lang=js"

import "./FieldsTable.vue?vue&type=style&index=0&id=c391591c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c391591c"]])

export default __exports__